import {
  apiGet,
  apiPost,
  clearAuthStorage,
  getRefreshToken,
  setAuthToken,
  setRefreshToken,
  setSiteSlug,
  STORAGE_KEYS,
  normalizeSiteSlug,
  getSiteSlug,
  clearSiteCache,
} from "./api";

function saveUser(user) {
  try {
    if (user) {
      localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user));
    } else {
      localStorage.removeItem(STORAGE_KEYS.user);
    }
  } catch (error) {
    console.error("Gagal menyimpan user:", error);
  }
}

function getMembershipsFromUser(user) {
  if (Array.isArray(user?.memberships)) return user.memberships;
  if (Array.isArray(user?.site_memberships)) return user.site_memberships;
  return [];
}

function pickMembershipSiteSlug(user) {
  const memberships = getMembershipsFromUser(user);
  const current = normalizeSiteSlug(getSiteSlug());

  if (!memberships.length) {
    return current || "";
  }

  const matched = memberships.find(
    (item) =>
      normalizeSiteSlug(item?.site_slug || item?.site?.slug) === current
  );

  if (matched) {
    return normalizeSiteSlug(matched?.site_slug || matched?.site?.slug);
  }

  return current || "";
}

function persistAuthPayload(data) {
  const token = data?.access || data?.token || data?.access_token || data?.jwt || "";
  const refresh = data?.refresh || getRefreshToken() || "";
  const user = data?.user || data?.profile || data?.data?.user || data?.data || null;

  if (token) setAuthToken(token);
  if (refresh) setRefreshToken(refresh);
  if (user) saveUser(user);

  const resolvedSiteSlug = pickMembershipSiteSlug(user);
  if (resolvedSiteSlug) {
    setSiteSlug(resolvedSiteSlug);
  }

  return { token, refresh, user };
}

export async function login(payload) {
  const username = payload?.username || payload?.email || "";
  const data = await apiPost("/auth/login/", {
    username,
    email: payload?.email || "",
    password: payload?.password || "",
  });

  persistAuthPayload(data);
  return data;
}

export async function register(payload) {
  return apiPost("/auth/register/", payload);
}

export async function forgotPassword(payload) {
  return apiPost("/auth/forgot-password/", payload);
}

export async function resetPassword(payload) {
  return apiPost("/auth/reset-password-confirm/", payload);
}

export async function refreshToken(payload) {
  const data = await apiPost("/auth/refresh/", payload || { refresh: getRefreshToken() });
  persistAuthPayload(data);
  return data;
}

export async function getProfile() {
  const data = await apiGet("/auth/profile/");
  const user = data?.user || data?.profile || data?.data || data;

  if (user) {
    persistAuthPayload({ user });
  }

  return data;
}

export async function getUsersBySite(siteId) {
  if (!siteId) return { results: [] };
  return apiGet("/users/", { site_id: siteId });
}

export async function logout() {
  const refresh = getRefreshToken();

  try {
    if (refresh) {
      await apiPost("/auth/logout/", { refresh });
    }
  } catch (error) {
    console.warn("Logout API gagal, local session tetap dibersihkan:", error);
  } finally {
    clearAuthStorage();
    clearSiteCache();
  }
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.user);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Gagal membaca stored user:", error);
    return null;
  }
}